const PP10 = [
    {
        "index": 1,
        "content": "こんにちは。お話して大丈夫ですか？",
        "person": "A",
        "role": "normal",
    },
    {
        "index": 2,
        "content": "はい、大丈夫です。今、飼っている熱帯魚の世話をしていたところです。",
        "person": "user",
        "role": "normal",
    },
    {
        "index": 3,
        "content": "ほほお熱帯魚ですか。きれいなことでしょうね。",
        "person": "A",
        "role": "normal",
    },
    {
        "index": 4,
        "content": "はい、私はエステティシャンをしていて、普段忙しいのでとても癒されます。",
        "person": "user",
        "role": "normal",
    },
    {
        "index": 5,
        "content": "華やかそうなお仕事で羨ましいですね。わたしは先日定年を迎えて自由の身になりました。",
        "person": "A",
        "role": "normal",
    },
    {
        "index": 6,
        "content": "そうなんですね。ゆっくりされてくださいね。私はネイリストも目指しているところです。",
        "person": "user",
        "role": "normal",
    },
    {
        "index": 7,
        "content": "それでは総合美容家を目指せそうですね。わたしは体で自慢できるのは虫歯がないことぐらいなんで、美しさに磨きをかける方は尊敬します。",
        "person": "A",
        "role": "normal",
    },
    {
        "index": 8,
        "content": "ありがとうございます。虫歯がないなんて、とても羨ましいです！",
        "person": "user",
        "role": "normal",
    },
    {
        "index": 9,
        "content": "その代わり髪は薄いので、美容とは縁がありません。",
        "person": "A",
        "role": "normal",
    },
    {
        "index": 10,
        "content": "定年されたので、これからおしゃれしても良いと思いますよ。ちなみに私は岩手出身ですが、あなたはどちらですか？",
        "person": "user",
        "role": "scain",
    },
    {
        "index": 11,
        "content": "岩手の方なんですか。わたしは宮城の出身なので近いですね。",
        "person": "A",
        "role": "scain",
    },
    {
        "index": 12,
        "content": "それは近いですね！奇遇です。ねぇBさん。そういえばBさんはどうでしたっけ？",
        "person": "user",
        "role": "core",
    },
    {
        "index": 13,
        "content": "私もエステティシャンなんですよ。お互いにリラックスできることが大事ですね。",
        "person": "B",
        "role": "normal",
    },
];

export default PP10;